module.exports = new __parcel__URL__("permission-error.da9ec123.svg").toString();